module.exports = __webpack_public_path__ + "static/media/landing-page-herounit-lead-01.59f6c1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/landing-page/landing-page-herounit-lead-01.png
// module id = 239
// module chunks = 0